import { Box, InputBase, styled } from "@mui/material";

import {
    COLORS,
    RADIUS,
    SHADOW,
    TYPOGRAPHY,
} from "../../SignalWizard.constants";
import { transientOptions } from "../../SignalWizard.styled";

export const NameCard = styled(Box)({
    padding: 20,
    marginBottom: 40,
    backgroundColor: COLORS.surfaceLowest,
    borderRadius: RADIUS.card,
    border: `1px solid ${COLORS.border}`,
    boxShadow: SHADOW.sm,
});

export const FieldLabel = styled("label")({
    display: "block",
    marginBottom: 6,
    color: COLORS.primary,
    ...TYPOGRAPHY.labelMd,
});

export const NameInput = styled(
    InputBase,
    transientOptions,
)<{
    $hasError?: boolean;
}>(({ $hasError }) => ({
    width: "100%",
    maxWidth: 448,
    padding: "0 12px",
    backgroundColor: COLORS.surfaceLowest,
    color: COLORS.onSurface,
    borderRadius: RADIUS.control,
    border: `1px solid ${$hasError ? COLORS.error : COLORS.border}`,
    boxShadow: SHADOW.sm,
    transition: "border-color 150ms, box-shadow 150ms",
    ...TYPOGRAPHY.bodyMd,
    "& input": {
        padding: "8px 0",
        height: "auto",
        "&::placeholder": { color: COLORS.outlineVariant, opacity: 1 },
    },
    "&.Mui-focused": {
        borderColor: $hasError ? COLORS.error : COLORS.primary,
        boxShadow: "0 0 0 2px rgba(0, 0, 0, 0.05)",
    },
}));

export const ErrorText = styled("span")({
    display: "block",
    marginTop: 6,
    color: COLORS.error,
    ...TYPOGRAPHY.bodySm,
});

export const HelpNote = styled("p")({
    display: "flex",
    alignItems: "center",
    gap: 6,
    margin: "12px 0 0",
    color: COLORS.onSurfaceVariant,
    ...TYPOGRAPHY.bodySm,
    "& svg": { fontSize: 15, color: COLORS.outline },
    "& a": {
        color: COLORS.primary,
        fontWeight: 500,
        textDecoration: "underline",
    },
});

export const SummaryGrid = styled(Box)(({ theme }) => ({
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: 24,
    [theme.breakpoints.up("md")]: {
        gridTemplateColumns: "1fr 1fr",
    },
}));
